<template>
  <div class="workgroup">
    <div class="view-title">
      <translate>Work Group List</translate>
    </div>
    <div class="content">
      <!--搜索头部-->
      <div class="search-header">
        <el-button type="text" @click.stop="onShowCreateWorkgroupAdd()">
          <i class="fa fa-plus fa-lg"></i>
          <translate>Created New Workgrounp</translate>
        </el-button>
        <div class="pull-right">
          <el-form :inline="true" class="demo-form-inline">
            <el-select v-model="search.condition" :placeholder="attrText.select" class="searchSelect" @change="clearSearchInput">
              <el-option :label="attrText.name" value="q_name"></el-option>
              <el-option label="IP" value="q_ip"></el-option>
            </el-select>
            <el-input class="searchInput" v-model.trim="search.name" :disabled="!search.condition" @keyup.enter.native="onSearch()" ></el-input>
            <el-button class="search-btn" @click="onSearch">
              <translate>Search</translate>
            </el-button>
          </el-form>
        </div>
      </div>
      <!--table-->
      <el-table :data="workGroup.list" style="width: 100%" :show-header="false" :row-class-name="tableRowClassName" v-loading="loading">
        <el-table-column>
          <template scope="scope">
            <router-link :to="{name:'settingWorkgroupDetail', params: {id: scope.row.id}, query: {type: 'ecs'}}">
              <el-button type="text">
                <span class="project-name">{{ scope.row.name }}</span>
              </el-button>
              <el-tooltip class="item" effect="dark" :content="attrText.defaultWorkgroup" placement="top" v-if="scope.row.network_id !== -1">
                <i class="fa fa-globe" aria-hidden="true"></i>
              </el-tooltip>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="desc">
          <template scope="scope">
            {{ scope.row.desc ? scope.row.desc : '-' }}
          </template>
        </el-table-column>
        <el-table-column>
          <template scope="scope">
            {{getTranTest(scope.row.resource_count)}}
          </template>
        </el-table-column>
        <el-table-column>
          <template scope="scope">
            {{getTranMember(scope.row.account_count)}}
          </template>
        </el-table-column>
        <el-table-column width="180" class="text-right">
          <template scope="scope">
            <router-link :to="{name:'settingWorkgroupDetail', params: {id: scope.row.id}, query: {type: 'ecs'}}">
              <el-button type="text">
                <translate>Details</translate>
              </el-button>
            </router-link>
            <el-button type="text" @click.stop="onShowCreateWorkgroupSetting(scope.row)">
              <translate>Setting</translate>
            </el-button>
            <el-button type="text" @click.stop="deleteResource(scope.row.id)" :disabled="scope.row.network_id !== -1">
              <translate>Delete</translate>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="workGroup.totalPage > 10">
        <el-pagination layout="total, prev, pager, next" :total="workGroup.totalPage" :page-size="10"
                       :current-page.sync="workGroup.currentPage" @current-change="onChangePage"></el-pagination>
      </div>
    </div>

    <component :is="currentRightPanel" :items="rightPanelData" @onClosePanel="onClosePanel"
               @callback="getWorkGroupList(workGroup.currentPage)"></component>

  </div>
</template>

<script>
  import STORE_CONST from '../../store/consts'
  import WorkgroupAdd from './model/workgroup-add'
  import WorkgroupSetting from './model/workgroup-setting'
  export default{
    data () {
      return {
        loading: true,
        search: {
          condition: 'q_name',
          name: '',
          params: []
        },
        workGroup: {
          list: [],
          totalPage: 0,
          currentPage: 1
        },
        currentRightPanel: null,
        rightPanelData: null
      }
    },
    computed: {
      attrText () {
        return this.getTranslateText()
      }
    },
    created () {
      this.getWorkGroupList()
    },
    methods: {
      getTranTest (clusters) {
        let translated = this.$ngettext('%{ n } resource', '%{ n } resources', clusters)
        let interpolated = this.$gettextInterpolate(translated, {n: clusters})
        return interpolated
      },
      getTranMember (clusters) {
        let translated = this.$ngettext('%{ n } member', '%{ n } members', clusters)
        let interpolated = this.$gettextInterpolate(translated, {n: clusters})
        return interpolated
      },
      // 提取翻译文本
      getTranslateText () {
        return {
          inputName: this.$gettext('Please input WokGroup Name'),
          defaultWorkgroup: this.$gettext('default workgroup'),
          select: this.$gettext('select'),
          name: this.$gettext('Name')
        }
      },
      // 获取工作组列表
      getWorkGroupList (page, total) {
        let params = {
          page: page || 1
        }
        if (this.search.name !== '' && this.search.condition) {
          params[this.search.condition] = this.search.name
        }
        if (total) { params.total = total }
        this.$store.dispatch(STORE_CONST.WORKGROUP.LIST_WORKGROUP, params).then(res => {
          this.loading = false
          this.workGroup = Object.assign({}, {
            list: res.objects,
            totalPage: res.total,
            currentPage: res.page
          })
        }, () => {
          this.loading = false
        })
      },
      // 搜索
      onSearch () {
        this.getWorkGroupList()
      },
      // 清空搜索框
      clearSearchInput () {
        this.search.name = ''
      },
      // 删除资源
      deleteResource (id) {
        this.$confirm(this.$gettext('Are you sure to delete this project?'), this.$gettext('Delete Confirm'), {
          confirmButtonText: this.$gettext('Comfirm'),
          cancelButtonText: this.$gettext('Cancel'),
          type: 'warning'
        }).then(() => {
          this.$store.dispatch(STORE_CONST.WORKGROUP.DELETE_WORKGROUP, id).then(() => {
            this.clearSearchInput()
            this.getWorkGroupList(this.workGroup.currentPage)
            this.$notify({
              type: 'success',
              message: this.$gettext('Delete successfully!')
            })
          })
        })
      },
      // 分页
      onChangePage (page) {
        this.getWorkGroupList(page, this.workGroup.totalPage)
      },
      tableRowClassName (row, index) {
        if (index % 2 === 0) {
          return 'info-row'
        }
        return ''
      },
      // 关闭侧滑回调
      onClosePanel () {
        this.currentRightPanel = null
        this.rightPanelData = null
      },
      // 显示创建工作组
      onShowCreateWorkgroupAdd () {
        const time = !this.currentRightPanel || this.currentRightPanel.name === 'WorkgroupAdd' ? 0 : 300
        this.currentRightPanel = WorkgroupAdd
        this.$nextTick(() => {
          setTimeout(() => {
            this.rightPanelData = {
              'name': {
                label: this.$gettext('Workgroup Name'),
                val: '',
                rule: [
                  {
                    required: true, message: this.$gettext('Please input the workgroup name'), trigger: 'blur'
                  },
                  {min: 2, message: this.$gettext('2-255 characters'), trigger: 'change'},
                  {max: 255, message: this.$gettext('2-255 characters'), trigger: 'change'}
                ]
              },
              'tips': {
                type: 'tips',
                text: this.$gettext('Note: A workgroup can allocate up to 1000 resources')
              },
              'desc': {
                label: this.$gettext('Describe'),
                val: '',
                rule: [
                  {max: 140, message: this.$gettext('length is within 140 characters'), trigger: 'change'}
                ],
                type: 'textarea',
                options: {
                  autosize: true,
                  resize: '300'
                }
              }
            }
          }, time)
        })
      },
      // 显示设置工作组
      onShowCreateWorkgroupSetting (row) {
        console.log('row', row)
        const time = !this.currentRightPanel || this.currentRightPanel.name === 'WorkgroupSetting' ? 0 : 300
        this.currentRightPanel = WorkgroupSetting
        this.$nextTick(() => {
          setTimeout(() => {
            this.rightPanelData = row
          }, time)
        })
      }
    },
    components: {
      WorkgroupAdd,
      WorkgroupSetting
    }
  }
</script>

<style lang='scss' rel="stylesheet/scss">
  @import "../../assets/css/variable";

  .workgroup {
    .content{
      padding: 15px;
    }
    .cell {
      a {
        color: $textColor;
        .el-button--text{
          max-width: calc(100% - 10px);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        &:hover {
          color: $mainColor;
        }
      }
    }
    .search-header {
      height: 60px;
      line-height: 60px;
      padding: 0 15px;
      background-color: #fff;
      border: 1px solid $border-color;
      border-bottom: none;
      .el-button--text {
        color: $textColor;
        &:hover {
          color: $mainColor;
        }
      }
      .pull-right {
        .searchInput {
          width: 180px;
        }
        .search-btn {
          height: 32px;
          min-width: 88px;
          padding: 0;
        }
        .searchSelect {
          width: 100px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// workgroup.vue?22f68f6a